import styled from 'styled-components';
import { PageHeader } from 'antd';

export const StyledPageHeader = styled(PageHeader)`
  margin-bottom: 2rem;
  padding: 1.6rem 0;
`;

export const PageHeaderTitle = styled.h1`
  font-size: 2rem;
  font-weight: 600;
  margin: 0;
`;
